import { Button } from '@/components/ui/button';
import { useDealContext } from '@/contexts/deal-provider';
import { useDealByShortId } from '@/hooks/use-deals-selectors';
import {
  FEATURE_FLAG_NAMES,
  useIsFeatureEnabled,
} from '@/hooks/use-feature-flags';
import { toast } from '@/hooks/use-toast';
import { pdkAxios } from '@/lib/pdk-axios';
import { cn } from '@/lib/utils';
import { dealStore } from '@/models/stores';
import { useMutation } from '@tanstack/react-query';
import { RefreshCcwDot } from 'lucide-react';
import { useState } from 'react';

export const ReactivateButton = () => {
  const [reactivating, setReactivating] = useState(false);
  const { currentShortId } = useDealContext();
  const deal = useDealByShortId(currentShortId);
  const { isFeatureEnabled } = useIsFeatureEnabled({
    featureFlagName: FEATURE_FLAG_NAMES.REACTIVATE_DEAL,
  });

  const reactiveMutation = useMutation({
    onMutate: async () => {
      setReactivating(true);
    },
    mutationFn: async () => {
      const response = await pdkAxios
        .post(`/deals/${deal?.id}/reactivate`)
        .catch((e) => {
          console.error('Error reactivating deal', e);
          throw e;
        });
      return response.data;
    },
    onSuccess: () => {
      setReactivating(false);
      dealStore.updateStatus({ id: deal?.id!, status: 'in_progress' });
      toast({
        title: 'Deal reactivated',
      });
    },
  });
  if (!deal || deal.status !== 'cancelled') {
    return null;
  }

  const activeDealsWithSameVehicleListing =
    dealStore.getActiveDealsByVehicleListingId(deal.vehicle_listing_id);

  if (activeDealsWithSameVehicleListing.length > 0) {
    return null;
  }

  const handleReactivate = () => {
    setReactivating(true);
    reactiveMutation.mutate();
  };

  return (
    <Button
      onClick={handleReactivate}
      variant="ghost"
      className="p-1 h-fit border rounded-md mr-2"
      disabled={reactivating || !isFeatureEnabled}
    >
      <RefreshCcwDot
        className={cn('size-3', { 'animate-spin': reactivating })}
      />
      <span className="text-xs  text-gray-500">
        {reactivating ? 'Reactivating...' : 'Reactivate'}
      </span>
    </Button>
  );
};
